// login

//AUTH
export const AUTH1302 = 'AUTH1302';
export const POLL_PENDING = 'EXTCS1016';

//reset password
//
//Utente ha un metodo di verifica non valido per operazione richiesta. Es 'Forgot Password' senza app enrollata
export const INVALID_AUTH_METHOD = 'EXTCS1010';
